import { useContext, useEffect, useMemo, useState } from "react";
import Table from "components/Table";
import Card from "components/card";
import { TABLE_COLUMN } from "./enum";
import { LayoutContext } from "context/LayoutContext";
import InputSearch from "components/Form/InputSearch";
import { useToast } from "@chakra-ui/react";
import { debounce } from "helper/index";
import Tabs from "components/Tabs";
import { MdRemoveRedEye } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { approvalKasDeposit, getKasDeposit } from "apis/kas_deposit";
import Confirmation from "components/Modal/Confirmation";
import InputText from "components/Form/InputText";
import moment from "moment";
import { getUser } from "helper/localstorage";
import ModalApprovalKasDeposit from "./ModalApprovalKasDeposit";

const KasDeposit = () => {
  const navigate = useNavigate();
  const { setHeaderComponent } = useContext(LayoutContext);
  const toast = useToast();
  const [stockListData, setStockListData] = useState([]);
  const [table, setTable] = useState({
    loading: false,
    pagination: { total: 1, current_page: 1, per_page: 10 },
    watch: {
      keyword: "",
      id_gudang: "",
      id_user: "",
    },
  });

  const fetchStock = async (params = {}) => {
    try {
      const res = await getKasDeposit(params);
      setStockListData(res.data);
      setTable((prev) => ({
        ...prev,
        pagination: {
          total: res.last_page,
          per_page: res.per_page,
          current_page: res.current_page,
        },
      }));
    } catch (error) {
      toast({
        title: "Gagal mendapatkan data pelanggan",
        status: "error",
        isClosable: true,
        position: "top-center",
      });
    }
  };

  useEffect(() => {
    fetchStock({ page: 1, limit: 10, approval_status: 1 });
    setHeaderComponent(
      <div className="flex h-full items-end justify-end gap-3">
        {/* <Button label="Export Excel" variant="GHOST" size="sm" leftIcon={<MdOutlineFileUpload />} /> */}
      </div>
    );
  }, []);

  const { id } = getUser();
  const [selectedTab, setSelectedTab] = useState("loading_stock");
  const [approval, setApproval] = useState({ show: false, data: "" });
  useEffect(() => {
    fetchStock({
      page: 1,
      limit: 10,
      approval_status: selectedTab === "loading_stock" ? 1 : 0,
      ...(table.watch.keyword && { keyword: table.watch.keyword }),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table.watch, selectedTab]);

  const actionButton = {
    accessorKey: "user_sales",
    header: "Aksi",
    cell: (info) => (
      <>
        <div className="flex gap-1">
          <button
            className="flex items-center justify-center rounded-lg bg-[#BEDBFE] px-4 py-2 text-sm text-[#3A65FF]"
            onClick={() => {
              setApproval({ show: true, data: info.row.original });
            }}
          >
            Approve
          </button>
        </div>
      </>
    ),
  };

  const tabs = [
    {
      id: "loading_stock",
      label: "Daftar Setoran Kas",
      count: null,
      component: (
        <Table
          columnsData={TABLE_COLUMN}
          tableData={stockListData}
          paginationCallback={(page, offset) =>
            fetchStock({
              page,
              limit: offset,
              ...(table.watch.keyword && { keyword: table.watch.keyword }),
              approval_status: 1,
            })
          }
          currentPage={table.pagination.current_page}
          perPage={table.pagination.per_page}
          pageCount={table.pagination.total}
        />
      ),
    },
    {
      id: "approval_loading_stock",
      label: "Daftar Approval Setoran Kas",
      count: null,
      component: (
        <Table
          columnsData={[...TABLE_COLUMN, actionButton]}
          tableData={stockListData}
          paginationCallback={(page, offset) =>
            fetchStock({
              page,
              limit: offset,
              ...(table.watch.keyword && { keyword: table.watch.keyword }),
              approval_status: 0,
            })
          }
          currentPage={table.pagination.current_page}
          perPage={table.pagination.per_page}
          pageCount={table.pagination.total}
        />
      ),
    },
  ];

  return (
    <Card
      extra={
        "w-full h-full p-6 sm:overflow-x-auto flex-grow mt-5 flex flex-col"
      }
    >
      <div className="relative flex items-end gap-3">
        <div className="flex-grow">
          <InputSearch
            changeHandler={debounce((e) => {
              setTable((prevQuery) => ({
                ...prevQuery,
                watch: { ...prevQuery.watch, keyword: e.target.value },
              }));
            }, 500)}
            rounded
          />
        </div>
      </div>
      <div className="mt-8 flex flex-grow overflow-x-scroll xl:overflow-hidden">
        <Tabs
          tabs={tabs}
          value={selectedTab}
          onChange={(e) => setSelectedTab(e)}
        />
      </div>

      <ModalApprovalKasDeposit
        approval={approval}
        setApproval={setApproval}
        callback={async () => {
          await fetchStock({
            page: 1,
            limit: 10,
            approval_status: 0,
          });

          toast({
            title: "Berhasil approve kas deposit",
            status: "success",
            isClosable: true,
            position: "top-center",
          });

          setApproval({ show: false, data: null });
        }}
      />
    </Card>
  );
};

export default KasDeposit;
